import { REQUEST_FIRST_SIGN_IN, FIRST_SIGN_IN_SUCCESS, FIRST_SIGN_IN_FAILURE, RESET_FIRST_SIGN_IN } from '../constants/action_types';
import{postForgotPassword} from '../api/api';
import { showEmailSent } from './signInModal';

const requestFirstSignIn = () => ({
    type: REQUEST_FIRST_SIGN_IN
});

const firstSignInSuccess = (data) => ({
    type: FIRST_SIGN_IN_SUCCESS,
    data
});

const firstSignInFailure = () => ({
    type: FIRST_SIGN_IN_FAILURE
});

const resetFirstSignIn = () => ({
    type: RESET_FIRST_SIGN_IN
});

const submitFirstSignIn = (data) => dispatch => {
    dispatch(requestFirstSignIn());
    
    const normalizeEmail = {
        "email": data
    }
    
    return postForgotPassword(normalizeEmail)
        .then(res => {
            if (!res.ok) {
                return dispatch(firstSignInFailure());
            } 
            return (
                dispatch(firstSignInSuccess(res.body.data))
                    .then(dispatch(showEmailSent(data)))
            );
        })
        .catch(error => {
            return dispatch(firstSignInFailure());
        });
};

export {
    submitFirstSignIn,
    resetFirstSignIn
};
